import { render, staticRenderFns } from "./PointCardListItem.vue?vue&type=template&id=01627fb9&scoped=true"
import script from "./PointCardListItem.vue?vue&type=script&lang=js"
export * from "./PointCardListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01627fb9",
  null
  
)

export default component.exports